import React, { useState } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";

function Footer() {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <footer
      className={`bg-gray-900 text-white fixed bottom-0 left-0 w-full transition-all duration-300 z-50 ${
        isCollapsed ? "h-4" : "h-12"
      }`}
    >
      {/* Toggle Button */}
      <div
        className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gray-700 w-10 h-6 rounded-full flex items-center justify-center cursor-pointer"
        onClick={() => setIsCollapsed(!isCollapsed)}
      >
        {isCollapsed ? (
          <ChevronUp className="text-white w-4 h-4" />
        ) : (
          <ChevronDown className="text-white w-4 h-4" />
        )}
      </div>

      {/* Footer Content */}
      {!isCollapsed && (
        <div className="text-center py-1">
          <p className="text-xs">
            © {new Date().getFullYear()} iDecisionLab AI Technologies Pvt. Limited. All rights
            reserved.
          </p>
          <p className="text-xs">
            Version 1.0.0 | <a href="#" className="underline">Privacy Policy</a>
          </p>
        </div>
      )}
    </footer>
  );
}

export default Footer;